// extracted by mini-css-extract-plugin
export default {"button":"ContainedButton_button__5xJXF"};